var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { FILTER_DATA, HOLDING_REPORT, OMNE_ONLY, QUANTITY_BREAKDOWN, SCREENSTATE, SEARCH, SELECTED_STOCK, SORT_DATA, SUMMARIZE, } from "@redux/interfaces/Reports/CoreReports/iHolding";
import { EREPORTSCREENSTATE } from "@domains/aggregates/interfaces/Reports/iHoldingReport";
import { ESortOrder } from "@domains/utils/sort";
import { combineReducers } from "redux";
import { ERevampReportReducers } from "@adapters/presenters/action-interfaces/Reports/common/CommonReportInterfaces";
import commonOnePlatFormReducer, { CommonOnePlatFormInitState, } from "@redux/reducers/common/commonReducer";
var initHoldingReport = {
    holdings: {
        HoldingDetails: [],
        HoldingSummary: {
            date: "",
            message: "",
            totalInvestment: "0",
            currentValue: "0",
            totalPnL: "0",
            daysPnL: "0",
            totalPnLChange: "0",
            daysPnLChange: "0",
        },
    },
    sortData: {
        sortState: [],
        sortRecord: {
            title: "",
            key: "",
            order: ESortOrder.ASC,
            orderText: {
                asc: "",
                desc: "",
            },
        },
        data: [],
    },
    filterData: {
        simpleFilter: {
            name: "",
            filters: [],
        },
        assetFilter: {
            name: "",
            filters: [],
        },
    },
    summarize: false,
    search: "",
    quantityBreakDown: false,
    screenState: EREPORTSCREENSTATE.L1,
    selectedStock: undefined,
    isOmneOnly: false,
    goBackState: false, // true when going back  from L3 to L1
};
var HoldingReducer = function (state, action) {
    if (state === void 0) { state = initHoldingReport; }
    switch (action.type) {
        case HOLDING_REPORT:
            return __assign(__assign({}, state), { holdings: action.payload.holdings });
        case OMNE_ONLY:
            return __assign(__assign({}, state), { isOmneOnly: action.payload.isOmneOnly });
        case FILTER_DATA:
            return __assign(__assign({}, state), { filterData: action.payload.filterData });
        case SORT_DATA:
            return __assign(__assign({}, state), { sortData: action.payload.sortData });
        case SUMMARIZE:
            return __assign(__assign({}, state), { summarize: action.payload.summarize });
        case SEARCH:
            return __assign(__assign({}, state), { search: action.payload.search });
        case QUANTITY_BREAKDOWN:
            return __assign(__assign({}, state), { quantityBreakDown: action.payload.quantityBreakDown });
        case SCREENSTATE:
            return __assign(__assign({}, state), { screenState: action.payload.screenState, goBackState: action.payload.goBackState });
        case SELECTED_STOCK:
            return __assign(__assign({}, state), { selectedStock: action.payload.selectedStock });
        default:
            return __assign({}, state);
    }
};
export default combineReducers({
    reducersData: HoldingReducer,
    commonData: function (state, action) {
        if (state === void 0) { state = new CommonOnePlatFormInitState(); }
        return commonOnePlatFormReducer(state, action, ERevampReportReducers.HOLDING);
    },
});
